import {NgModule} from '@angular/core';
import {RangeDirective} from './range.directive';

@NgModule({
  declarations: [RangeDirective],
  exports: [RangeDirective],
})
export class RangesModule {}
